import * as React from 'react';
import { ComplexValue, LoadOptions } from 'app/types-shared';
import { CodeComplexValue } from 'app/area/shared/codetable/types';
import { ImportMappingsTranslation } from 'app/area/import-mappings/constants';
import { PromptConfirmation } from 'ui';
import { LoadCodeItemsParams } from 'app/area/import-mappings/types';
import { CategorySinglePicker } from 'app/area/import-mappings/list-items/components/category-single-picker';
import { usePromptOnChange } from 'app/area/import-mappings/list-items/components/prompt-on-change';
import { ImportMappingsOptions } from 'app/area/import-mappings/types-store';
import { manageOptionsButton } from 'app/area/shared/manage-options';

interface FilterDetailsCategoryProps {
  componentId: string;
  label: string;
  shouldPrompt: boolean;
  codetableId: number;
  valueItem: ComplexValue<number>;
  options: ImportMappingsOptions;
  optionsParams?: { [key: string]: boolean | string[] };
  loadOptionsParams?: LoadOptions;
  translation: ImportMappingsTranslation;
  onChange: (value: CodeComplexValue<number>) => void;
  loadCodetableOptions: (
    id: string,
    codetableId: number,
    loadOptionsParams: LoadOptions,
    optionsParams?: LoadCodeItemsParams) => void;
}

export const FilterDetailsCategoryPicker = (props: FilterDetailsCategoryProps) => {

  const {
    componentId, label, shouldPrompt, valueItem, codetableId, options, optionsParams, loadOptionsParams, translation,
    onChange, loadCodetableOptions
  } = props;

  const onLoadOptions = (id: string, params: LoadOptions) => {
    loadCodetableOptions(
      componentId,
      codetableId,
      params,
      {
        limitFieldsTo: optionsParams?.limitFieldsTo,
        displayNotSelected: loadOptionsParams?.displayNotSelected
      } as LoadCodeItemsParams);
  }

  const { displayPrompt, onPromptedChange, onContinue, onHide } = usePromptOnChange(shouldPrompt, onChange);

  return <>
    {shouldPrompt && displayPrompt
      && <PromptConfirmation
        title={translation.cancel_changes}
        description={translation.are_you_sure}
        continueText={translation.undo_all}
        cancelText={translation.go_back}
        onContinue={onContinue}
        onCancel={onHide} />}
    <div className="col-lg-6 col-sm-12">
      <CategorySinglePicker
        id={componentId}
        label={label}
        valueItem={valueItem}
        leafNodeOnly={true}
        options={options?.[componentId]?.codes}
        fetchingOptions={options?.[componentId]?.fetching}
        translation={translation}
        onLoadOptions={onLoadOptions}
        extraFooterButton={manageOptionsButton(translation.manage_options, codetableId)}
        onChange={onPromptedChange} />
    </div>
  </>;
};
